<template>
  <div class="h-screen flex items-center justify-center mask">
    <div class="w-full max-w-md">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.mask::after {
  content: '';
  height: 40vw;
  background-color: hsla(0, 0%, 100%, 1);
  width: 100%;
  left: 0;
  position: absolute;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg preserveAspectRatio='none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 500 76'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23fff;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Eslant-up-top%3C/title%3E%3Cpath class='cls-1' d='M500,54,457,24a48.52,48.52,0,0,0-27-6C400.63,19.84,0,76,0,76V0H500Z'/%3E%3C/svg%3E");
  --rotate: rotate(180deg);
  --scale: scaleX(1);
  transform: var(--scale) var(--rotate);
  z-index: -1;
  bottom: 0;
}
</style>
